// extracted by mini-css-extract-plugin
module.exports = {"split":"Split_split__2FmIk","top":"Split_top__1OVWc","bottom":"Split_bottom__jAwzn","center":"Split_center__1oPAr","baseline":"Split_baseline__3xi7S"};